import SEO from "../components/SEO";
import HomeBannerComponent from "../components/homePage/HomeBannerComponent";
import TechMarquee from "../components/shared/TechMarquee";
import HomeAboutComponent from "../components/homePage/HomeAboutComponent";
import HomeServicesComponent from "../components/homePage/HomeServicesComponent";
import ProcessTimeline from "../components/ProcessTimeline";
import HomeClientsProjectsComponent from "../components/homePage/HomeClientsProjectsComponent";
import HomeAiSection from "../components/homePage/HomeAiSection";
import FAQ from "../components/homePage/FAQ";
import ContactSection from "../components/homePage/ContactSection";
import SectionRail from "../components/shared/SectionRail";
import GutterThread from "../components/shared/GutterThread";

export const HomePage = () => {
  return (
    <div className="home">
      <SEO path="/" />
      <GutterThread />
      <SectionRail />
      <HomeBannerComponent />
      <TechMarquee />
      <HomeAboutComponent />
      <HomeServicesComponent />
      <ProcessTimeline />
      <HomeClientsProjectsComponent />
      <HomeAiSection />
      <FAQ />
      <ContactSection />
    </div>
  );
};

export default HomePage;
